import i18n from "../i18n";
import "./styles/price_calculator";

export const ExchangeRateButton = () => {
	const handleClick = () => {
		const closeOrderPanelEvent = new CustomEvent("closeOrderPanel");
		document.dispatchEvent(closeOrderPanelEvent);
	};

	return (
		<button
			type="button"
			className="exchange-rate-button"
			data-toggle="modal"
			data-target="#switch_currency_modal"
			onClick={handleClick}
		>
			<p className="exchange-rate-title">{i18n.t("currency.change.label")}</p>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="12"
				height="12"
				viewBox="0 0 12 12"
				fill="none"
			>
				<circle cx="6" cy="6" r="6" fill="#737373" />
				<path
					d="M8.08 3.864L7.6 4.416C7.144 4.032 6.664 3.792 6.04 3.792C5.368 3.792 4.904 4.072 4.904 4.584C4.904 5.72 8.168 5.376 8.168 7.328C8.168 8.24 7.496 8.864 6.368 8.984V9.992H5.728V9C5.032 8.944 4.216 8.648 3.752 8.184L4.176 7.56C4.664 7.992 5.304 8.24 5.96 8.24C6.84 8.24 7.272 7.944 7.272 7.4C7.272 6.168 4.008 6.504 4.008 4.64C4.008 3.736 4.704 3.136 5.728 3.048V2.048H6.368V3.048C7.12 3.128 7.632 3.464 8.08 3.864Z"
					fill="white"
				/>
			</svg>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="10"
				height="6"
				viewBox="0 0 10 6"
				fill="none"
			>
				<path
					d="M8.99988 1L5 4.99988"
					stroke="#2F353E"
					strokeWidth="2"
					strokeLinecap="round"
				/>
				<path
					d="M1 1L4.99988 4.99988"
					stroke="#2F353E"
					strokeWidth="2"
					strokeLinecap="round"
				/>
			</svg>
		</button>
	);
};
